<template>
  <div>
    <el-dialog width="600px" :close-on-click-modal="false" title="修改收货信息" :visible.sync="showDialog" center append-to-body @closed="close()">
      <el-form :model="formCancel" :rules="rules" ref="formCancel" label-width="100px">
        <el-form-item label="收货人：" prop="receiver">
          <el-input v-model="formCancel.receiver" placeholder="请输入收货人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="receiverPhone">
            <el-input type="tel" maxlength="11" v-model.number="formCancel.receiverPhone"  autocomplete="off" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="收货地址：" prop="address" class="address">
          <AddressSelect itemWidth="143px" @change="addressChange" :defaultData="cityDefault" ref="addressSelect"></AddressSelect>
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入收货地址" v-model="formCancel.address"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="mobileCode" class="code">
          <el-input class="code" type="text" v-model="formCancel.mobileCode"  maxlength="6" autocomplete="off" placeholder="请输入验证码"></el-input>
          <el-button @click="toSendCode" :disabled="isSending" class="send-btn" v-loading="sendLoading">
            <span style="font-size: 14px">{{codeText}}</span>
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="close" @click="close" size="medium">取消</el-button>
        <el-button class="sunbmit-btn" type="primary" @click="submit('formCancel')" size="medium">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { changeAddress, getAddress, sendCode } from '@/api/marketPromotion/activeData'
import AddressSelect from '@/components/work/AddressSelect'
export default {
  components: { AddressSelect },
  data () {
    return {
      formLabelWidth: '130px',
      showDialog: false,
      form: {},
      formCancel:{
        applyId: 0,
        receiver: '',
        receiverPhone: '',
        province: '',
        city: '',
        area: '',
        address: '',
        mobileCode: ''
      },
      cityDefault: null,
      codeText: '发送验证码',
      isSending: false,
      sendLoading: false,
      rules: {
        receiver: [{ required: true, message: '请输入收货人姓名！', trigger: 'change' }],
        receiverPhone: [{ required: true, message: '请输入联系电话！', trigger: 'change' }],
        address: [{ required: true, message: '请输入收货地址！', trigger: 'change' }],
        mobileCode: [{ required: true, message: '请输入验证码！', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init (id) {
      this.formCancel.applyId = id
      this.showDialog = true
      this.getAddress(id)
    },
    addressChange (val) {
      const { provinceCode, cityCode, countyCode } = val
      this.formCancel.province = provinceCode
      this.formCancel.city = cityCode
      this.formCancel.area = countyCode
    },
    toSendCode () {
      this.$refs.formCancel.validateField('receiverPhone', errMsg => {
        if (errMsg) {
          return false
        } else {
          this.sendCode()
        }
      })
    },
    setCountText () {
      this.codeText = '60s后重新发送'
      let count = 60
      let timer = setInterval(() => {
        this.codeText = `${count}s后重新发送`
        if (count === 0) {
          clearInterval(timer)
          this.isSending = false
          this.codeText = '发送验证码'
        } else {
          count--
          this.codeText = `${count}s后重新发送`
        }
      }, 1000)
    },
    close () {
       this.showDialog = false
       this.$refs.addressSelect.reset()
       this.$refs.formCancel.resetFields()
    },
    async sendCode () {
      this.sendLoading = true
      let { formCancel: { receiverPhone } } = this
      try {
        const { code } = await sendCode({ mobile: receiverPhone })
        if (code !== 200) return
        this.isSending = true
        this.setCountText()
      } catch (error) {
        console.log(error.message)
      } finally {
        this.sendLoading = false
      }
    },
    // 查询地址
    async getAddress (id) {
      try {
        const { code, result } = await getAddress({ applyId: id })
        if (code !== 200) return
        this.formCancel = {...this.formCancel, ...result}
        this.cityDefault = {
          provinceCode: result.province,
          cityCode: result.city,
          countyCode: result.area
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 提交
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.changeAddress(this.formCancel)
      })
    },
    async changeAddress (param) {
      try {
        const { code } = await changeAddress(param)
        if (code !== 200) return
        this.$message.success('修改成功')
        this.close()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.sunbmit-btn{
  background: #4B7EFE;
  width: 122px;
}
.close{
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #CCCCCC;
  width: 122px;
}
/deep/.el-textarea {
  margin-top: 8px;
}
/deep/.code .el-input {
  width: 300px;
  margin-right: 20px;
}
/deep/ .address .el-select {
  margin-right: 10px;
}
</style>
